export const blockIconsHardwarePhoneAndroidNew = (
	<span className='material-symbols-outlined'>phone_android</span>
);
